import { Grid, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import {
  createBanList,
  updateBanListById,
  getBanListById,
} from "../../../../../services/banList.service";
import { TBanListForm, banListSchema } from "./banListSchema";
import {
  AutoComplete,
  FormContainer,
  FormInput,
  Treturn,
  useFetch,
} from "@4uhub/lib4uhub";
import TicketServService from "../../../../../services/ticket.service";
import { Information } from "../../../../../components/Information/Information";

const ticketService = new TicketServService();

const translationPath = "chatBot.page.service.banList.";

const BanList = () => {
  const { t } = useTranslation();

  const { sendRequest: save, loading: sLoading } = useFetch(createBanList);

  const { sendRequest: update, loading: uLoading } =
    useFetch(updateBanListById);

  const { sendRequest: get, loading: gLoading } = useFetch(getBanListById);

  const saveHandler = async (v: TBanListForm) =>
    save({
      ...v,
      ticketServiceId: v.ticketService.id,
    });

  const updateHandler = (v: TBanListForm, id: string) =>
    update({
      item: {
        ...v,
        ticketServiceId: v.ticketService.id,
      },
      id: id,
    });

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TBanListForm>> => {
      const { data, success } = await get(id);
      if (data && success) {
        const newData: TBanListForm = {
          ...data,
        };
        return { data: newData, success: true };
      }

      return { data, success };
    },
    [get],
  );

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TBanListForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      loading={loading}
      title={t(translationPath + "ban_list")}
      schema={banListSchema}
      subtitle={t(translationPath + "new_ban_list")}
      fields={() => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Stack spacing={1} flex={1} direction="row">
              <FormInput
                name="phoneNumber"
                label={t(translationPath + "phone_number")}
                fullWidth
                size="small"
              />

              <Information
                title={t(translationPath + "phone_info")}
                iconSize="small"
                iconColor="action"
              />
            </Stack>
          </Grid>

          <Grid item xs={12} sm={6}>
            <AutoComplete
              getOptionLabel={(option) => {
                return option.name;
              }}
              size="small"
              label={t(translationPath + "ticket_service")}
              name="ticketService"
              request={ticketService.ticketServiceList}
            />
          </Grid>

          <Grid item xs={12}>
            <FormInput
              name="observation"
              label={t(translationPath + "observation")}
              fullWidth
              size="small"
              multiline
              minRows={3}
            />
          </Grid>
        </Grid>
      )}
    />
  );
};

export default BanList;
